/* Achilles · Sahel Edit — build 2 (product-image swipe) */
/* Achilles · Sahel Edit — editorial rhythm (2 AI + 1 full-width video / 10) + AI/video media swap on the
   REAL product cards, infinite-scroll tab loading, and force-resolve of lazy images on appended cards.
   The product card markup/functionality (sizes, add-to-cart, badges, swatches) is left untouched. */
(function () {
  'use strict';
  var MUTE_SVG =
    '<svg class="ach-sahel-mute__off" viewBox="0 0 24 24" fill="currentColor"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3a4.5 4.5 0 00-2.5-4v8a4.5 4.5 0 002.5-4zM14 3.2v2.1c2.9.9 5 3.6 5 6.7s-2.1 5.8-5 6.7v2.1c4-.9 7-4.5 7-8.8s-3-7.9-7-8.8z"/></svg>' +
    '<svg class="ach-sahel-mute__on" viewBox="0 0 24 24" fill="currentColor"><path d="M3 9v6h4l5 5V4L7 9H3zm10.5 3a4.5 4.5 0 00-2.5-4v2.2l2.4 2.4c.06-.2.1-.4.1-.6zM4.3 3L3 4.3 7.7 9H3v6h4l5 5v-6.7l4.3 4.3c-.6.5-1.4.9-2.3 1.1v2.1c1.4-.3 2.7-.9 3.7-1.8l2 2L21 19.7 4.3 3zM19 12c0 .9-.2 1.8-.5 2.6l1.5 1.5A8.9 8.9 0 0021 12c0-4.3-3-7.9-7-8.8v2.1c2.9.9 5 3.6 5 6.7z"/></svg>';
  var vio = null;

  function playOnly(v) {
    document.querySelectorAll('.ach-sahel-videowrap video').forEach(function (o) { if (o !== v) o.pause(); });
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  function registerVideo(v, btn) {
    if (!vio && 'IntersectionObserver' in window) {
      vio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio > 0.5) playOnly(e.target); else e.target.pause(); });
      }, { threshold: [0, 0.5, 1] });
    }
    if (vio) vio.observe(v);
    if (btn) {
      btn.setAttribute('aria-pressed', String(v.muted));
      btn.addEventListener('click', function (ev) {
        ev.preventDefault(); ev.stopPropagation();
        v.muted = !v.muted; btn.setAttribute('aria-pressed', String(v.muted));
        if (!v.muted) playOnly(v);
      });
    }
  }

  // Force a lazy <img> to actually load: pick a srcset candidate (~720w) and set it as src.
  function resolveImg(img) {
    if (!img || img.dataset.sahelHy) return;
    img.dataset.sahelHy = '1';
    var ss = img.getAttribute('srcset') || img.getAttribute('data-srcset');
    if (ss) {
      var cands = ss.split(',').map(function (s) { var p = s.trim().split(/\s+/); return { url: p[0], w: parseInt(p[1], 10) || 0 }; }).filter(function (c) { return c.url; });
      if (cands.length) { cands.sort(function (a, b) { return Math.abs(a.w - 720) - Math.abs(b.w - 720); }); img.src = cands[0].url; }
    }
    img.removeAttribute('loading');
    img.style.opacity = '1';
  }
  function hydrateCard(card) {
    card.querySelectorAll('.grid-product__image-mask img').forEach(resolveImg);
  }

  function shuffle(a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }

  // Spread media-bearing cards through a batch at RANDOM positions (media order shuffled, random offset)
  // so the AI/video cards recur and vary each load / collection. Non-media products keep their order.
  function spread(grid, cards, map) {
    var withM = [], plain = [];
    cards.forEach(function (c) { var m = map[c.getAttribute('data-product-id')]; ((m && (m.ai || m.video)) ? withM : plain).push(c); });
    if (!withM.length || !plain.length) return cards;
    shuffle(withM);
    var total = cards.length, step = total / withM.length, out = [], mi = 0, pi = 0;
    var nextM = Math.random() * step * 0.9;
    for (var i = 0; i < total; i++) {
      if (mi < withM.length && i >= Math.round(nextM)) { out.push(withM[mi++]); nextM += step; }
      else if (pi < plain.length) { out.push(plain[pi++]); }
      else if (mi < withM.length) { out.push(withM[mi++]); }
    }
    out.forEach(function (c) { grid.appendChild(c); });
    return out;
  }

  function mediaMap(grid) {
    var map = {};
    grid.querySelectorAll('script.ach-sahel-media').forEach(function (s) { try { var d = JSON.parse(s.textContent); if (d && d.id) map[d.id] = d; } catch (e) {} });
    return map;
  }
  function swapAI(card, url) {
    var img = card.querySelector('.grid-product__image-mask .grid__image-ratio img, .grid-product__image-mask .image-wrap img') || card.querySelector('.grid-product__image-mask img');
    if (!img) return;
    img.dataset.sahelHy = '1';
    img.srcset = url; img.src = url; img.setAttribute('data-src', url); img.setAttribute('data-srcset', url);
    img.removeAttribute('sizes'); img.removeAttribute('loading'); img.style.opacity = '1';
    card.classList.add('ach-sahel-ai');
  }
  function makeVideo(card, media) {
    var mask = card.querySelector('.grid-product__image-mask');
    if (!mask || mask.querySelector('.ach-sahel-videowrap')) return;
    card.classList.add('ach-sahel-full');
    var wrap = document.createElement('div'); wrap.className = 'ach-sahel-videowrap';
    var v = document.createElement('video');
    v.muted = true; v.loop = true; v.playsInline = true;
    v.setAttribute('playsinline', ''); v.setAttribute('muted', ''); v.setAttribute('preload', 'none');
    if (media.poster) v.setAttribute('poster', media.poster);
    var src = document.createElement('source'); src.src = media.video; src.type = 'video/mp4'; v.appendChild(src);
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'ach-sahel-mute';
    btn.setAttribute('aria-label', 'Toggle sound'); btn.setAttribute('aria-pressed', 'true'); btn.innerHTML = MUTE_SVG;
    wrap.appendChild(v); wrap.appendChild(btn);
    mask.appendChild(wrap);
    registerVideo(v, btn);
  }

  // one-time "swipe" hint (a small nudge) when a carousel first enters view
  var hintIO = null;
  function hintOnce(car) {
    if (!('IntersectionObserver' in window)) return;
    if (!hintIO) {
      hintIO = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio > 0.5 && !e.target._hinted) {
            e.target._hinted = 1;
            var c = e.target, w = c.clientWidth;
            c.scrollTo({ left: Math.round(w * 0.16), behavior: 'smooth' });
            setTimeout(function () { c.scrollTo({ left: 0, behavior: 'smooth' }); }, 520);
            hintIO.unobserve(c);
          }
        });
      }, { threshold: [0, 0.5, 1] });
    }
    hintIO.observe(car);
  }

  // Mouse drag-to-swipe (desktop) — touch devices scroll natively
  function enableDrag(car) {
    var down = false, moved = false, sx = 0, ss = 0;
    car.style.cursor = 'grab';
    car.addEventListener('pointerdown', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      down = true; moved = false; sx = e.clientX; ss = car.scrollLeft;
      car.style.scrollSnapType = 'none'; car.style.cursor = 'grabbing';
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true;
      car.scrollLeft = ss - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return; down = false; car.style.cursor = 'grab'; car.style.scrollSnapType = 'x mandatory';
      var w = car.clientWidth; if (w) car.scrollTo({ left: Math.round(car.scrollLeft / w) * w, behavior: 'smooth' });
    });
    var link = car.closest('a');
    if (link) link.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    car.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  // Swipeable image carousel (Alohas-style) inside the real card's image area
  function buildCarousel(card, slides) {
    var mask = card.querySelector('.grid-product__image-mask');
    if (!mask || mask.querySelector('.ach-sahel-carousel')) return;
    mask.classList.add('ach-sahel-has-carousel');
    var car = document.createElement('div'); car.className = 'ach-sahel-carousel';
    slides.forEach(function (u) {
      var s = document.createElement('div'); s.className = 'ach-sahel-slide';
      var im = document.createElement('img'); im.src = u; im.loading = 'lazy'; im.alt = '';
      s.appendChild(im); car.appendChild(s);
    });
    var dots = document.createElement('div'); dots.className = 'ach-sahel-dots';
    slides.forEach(function (_, i) { var d = document.createElement('span'); d.className = 'ach-sahel-dot' + (i === 0 ? ' is-active' : ''); dots.appendChild(d); });
    mask.appendChild(car); mask.appendChild(dots);
    // hide the theme's static image(s) behind the carousel
    mask.querySelectorAll('.grid__image-ratio img, .image-wrap img, .grid-product__secondary-image').forEach(function (el) { el.style.visibility = 'hidden'; });
    var dotEls = dots.children;
    car.addEventListener('scroll', function () {
      var idx = Math.round(car.scrollLeft / car.clientWidth);
      for (var i = 0; i < dotEls.length; i++) dotEls[i].classList.toggle('is-active', i === idx);
    }, { passive: true });
    enableDrag(car);
    hintOnce(car);
  }

  function applyRhythm(grid, reset, hydrate) {
    if (reset) grid._sIdx = 0;
    if (typeof grid._sIdx !== 'number') grid._sIdx = 0;
    var map = mediaMap(grid);
    var fresh = Array.prototype.slice.call(grid.querySelectorAll('.grid-product[data-product-id]:not([data-sahel-done])'));
    // boost: spread media-bearing cards through this batch so the special cards recur
    fresh = spread(grid, fresh, map);
    fresh.forEach(function (card) {
      card.setAttribute('data-sahel-done', '1');
      if (hydrate) hydrateCard(card);
      if (grid._sIdx % 6 === 0) grid._sVid = 0; // up to 1 video break per 6
      var m = map[card.getAttribute('data-product-id')];
      grid._sIdx++;
      if (!m) return; // no AI / no video: leave the real card static (not swipeable)
      if (m.video && grid._sVid < 1) { makeVideo(card, m); grid._sVid++; return; }
      // AI products feature/swipe their AI photos
      if (m.ai) {
        var slides = Array.isArray(m.ai) ? m.ai.slice() : [m.ai];
        if (slides.length >= 2) buildCarousel(card, slides);
        else if (slides.length === 1) swapAI(card, slides[0]);
        return;
      }
      // other products: swipe their own product photos
      if (m.images && m.images.length >= 2) buildCarousel(card, m.images);
    });
  }

  function initSection(root) {
    var grid = root.querySelector('[data-sahel-grid]');
    if (!grid) return;
    var loading = root.querySelector('[data-sahel-loading]');
    var sentinel = root.querySelector('[data-sahel-sentinel]');
    var wrap = root.querySelector('.ach-sahel__grid-wrap');
    var view = root.getAttribute('data-sahel-view') || 'sahel-ajax';
    var state = { handle: grid.getAttribute('data-collection'), page: 1, busy: false, hasMore: false };

    (function () { var m = grid.querySelector('[data-sahel-haspages]'); state.hasMore = !!(m && m.getAttribute('data-sahel-haspages') === '1'); if (m) m.remove(); })();
    applyRhythm(grid, true, false);

    root.querySelectorAll('[data-sahel-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (tab.classList.contains('is-active') || state.busy) return;
        root.querySelectorAll('[data-sahel-tab]').forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        state.handle = tab.getAttribute('data-collection');
        state.page = 1; state.hasMore = false;
        load(true);
      });
    });

    function load(replace) {
      if (!state.handle || state.busy) return;
      state.busy = true;
      root.classList.add('is-loading');
      if (loading) loading.hidden = false;
      var url = '/collections/' + encodeURIComponent(state.handle) + '?view=' + view + '&page=' + state.page;
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div'); tmp.innerHTML = html.trim();
          var m = tmp.querySelector('[data-sahel-haspages]');
          state.hasMore = !!(m && m.getAttribute('data-sahel-haspages') === '1');
          if (m) m.remove();
          if (replace) grid.innerHTML = '';
          while (tmp.firstChild) grid.appendChild(tmp.firstChild);
          grid.setAttribute('data-collection', state.handle);
          applyRhythm(grid, replace, true);
          if (replace && wrap) { window.scrollTo({ top: wrap.getBoundingClientRect().top + window.pageYOffset - 70, behavior: 'smooth' }); }
        })
        .catch(function () {})
        .then(function () {
          state.busy = false;
          root.classList.remove('is-loading');
          if (loading) loading.hidden = true;
          // if the sentinel is still on screen after a load, keep going
          maybeLoadMore();
        });
    }

    function maybeLoadMore() {
      if (!sentinel || state.busy || !state.hasMore) return;
      var r = sentinel.getBoundingClientRect();
      if (r.top < window.innerHeight + 600) { state.page += 1; load(false); }
    }

    // Infinite scroll
    if (sentinel && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting && state.hasMore && !state.busy) { state.page += 1; load(false); } });
      }, { rootMargin: '600px 0px' }).observe(sentinel);
    } else {
      window.addEventListener('scroll', function () { maybeLoadMore(); }, { passive: true });
    }
  }

  function boot() { document.querySelectorAll('.ach-sahel').forEach(initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
